<template>
  <div class="nlt">
    <div class="time_box">
      <data-type @getData="getTreeNodes" ref="datatype" :timeType="timeType" :showExporyytn="false" :timeInterval="toTime" :alarnclass="alarnclass"></data-type>
    </div>
    <div class="SankeyBox">
      <div id="Sankey"></div>
    </div>
  </div>
</template>
<script>
let vm;
import * as utils from "@/utils/index.js";
import DataType from "@/components/common/datatype";
export default {
  name: "Nlt",
  data () {
    return {
      //日期
      radio: "1",
      timeInterval: "toDay",
      toTime: "toTime",
      alarnclass: "alarnclass",
      timeType: [
        { value: "3", label: "时段" }
      ],
      //日期
      viewId: "",//视图ID
      scankeyData: {
        nodes: [],
        links: []
      },
      level: 1,//层级
      limit: 5//限制等级
    }
  },
  created () {
    vm = this;
  },
  mounted () {
    vm.getTreeNodes();//获取视图
  },
  methods: {
    fillSan () {
      vm.myChart = vm.$echarts.init(document.getElementById("Sankey"));
      let option = {
        tooltip: {
          trigger: 'item',
          triggerOn: 'mousemove',
          formatter: function (params) {
            return params.data.label + "<br/>" + params.data.measureId + "：" + params.value;
          }
        },
        series: [{
          type: 'sankey',
          data: vm.scankeyData.nodes,
          links: vm.scankeyData.links,
          layoutIterations: 0,
          label: {
            formatter: function (params) {
              return params.data.label;
            }
          },
          levels: [{
            depth: 0,
            itemStyle: {
              color: '#fbb4ae'
            },
            lineStyle: {
              color: 'source',
              opacity: 0.5
            }
          }, {
            depth: 1,
            itemStyle: {
              color: '#b3cde3'
            },
            lineStyle: {
              color: 'source',
              opacity: 0.5
            }
          }, {
            depth: 2,
            itemStyle: {
              color: '#ccebc5'
            },
            lineStyle: {
              color: 'source',
              opacity: 0.5
            }
          }, {
            depth: 3,
            itemStyle: {
              color: '#decbe4'
            },
            lineStyle: {
              color: 'source',
              opacity: 0.5
            }
          }]
        }
        ]
      }
      vm.myChart.setOption(option);
    },
    async getTreeNodes (time) {
      vm.scankeyData = {
        nodes: [],
        links: []
      }
      vm.level = 1;
      time ? "" : time = vm.$refs.datatype.getElem();
      let pageParams = await vm.$api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(vm.$store.state.user.currentCompanyId, "/nlt/nlt3", null);
      if (!pageParams.success) {
        vm.$message.error(pageParams.msg);
        return;
      }
      vm.viewId = utils.findDataByParam("fbt_view", false, pageParams.data);
      let views = []
      pageParams.data.forEach(item => {
        if (item.param == "pointInfo") {
          views = JSON.parse(item.value)
        }
      })
      let nodes = await vm.$api.view.getViewTreeNodes(vm.viewId);
      if (!nodes.success) {
        vm.$message.error(nodes.msg);
        return;
      }
      if (nodes.data.length == 0) {//没有节点数据
        vm.$message.error("没有节点数据");
        return;
      }
      let measures = [];
      nodes.data.map((item) => {
        measures.push({
          measureId: item.measureId,
          pointNumber: views.pointNumber,
          pointCode: views.pointCode
        });
      });
      let nodeVal = await vm.getData(time, measures);//获取统计量
      if (nodeVal.success) {//如果有数据
        nodeVal.data.map((item) => {
          item.value = item.value == null ? 0 : (item.value * 1).toFixed(2);
          let thisNode = nodes.data.find(val => val.measureId == item.measureId);
          thisNode.value = item.value;
        });
        let parentNode = vm.getTopParentNode(nodes.data);//获取当前列表的顶级计量点
        vm.scankeyData.links.push({
          label: parentNode.label,
          value: parentNode.value,
          measureId: parentNode.measureId,
          source: parentNode.parentId,
          target: parentNode.id
        });
        vm.recursion(nodes.data, [parentNode]);
        nodes.data.map((item) => {
          let tempItem = vm.scankeyData.links.find(i => i.source === item.parentId);
          if (tempItem) {
            vm.scankeyData.nodes.push({
              name: item.id,
              label: item.measureName,
              measureId: item.measureId
            });
          }
        });
        vm.fillSan();
      }
    },
    getTopParentNode (data) {//查找顶级节点，思路是找parentId最小的那一个
      if (data.length == 0) {
        return "当前视图下没有节点信息";
      }
      let node = data[0];
      data.forEach(element => {
        element.parentId < node.parentId ? node = element : "";
      });
      return node;
    },
    recursion (data, parentNode) {//递归添加节点数据,data:数据源,
      let jumpNode = [];
      let tempItem = [];
      data.map(item => {
        let temp = parentNode.find(i => i.id === item.parentId);
        if (temp) {
          jumpNode.push(item);
        }
      });
      jumpNode.map((item) => {
        vm.scankeyData.links.push({
          source: item.parentId,
          target: item.id + '',
          value: item.value || 0,
          label: item.measureName,
          measureId: item.measureId
        });
        tempItem.push(item);
      });
      vm.level++;
      if (vm.level < vm.limit && jumpNode.length != 0) {
        vm.recursion(data, tempItem);
      }
    },
    async getData (time, measures) {//查询统计量
      return await vm.$api.quantity.getQuantity2(JSON.stringify(measures), time.fromDate, time.toDate, 0);
    }
  },
  components: {
    DataType
  }
}
</script>
<style lang="scss" scoped>
.nlt {
  width: 100%;
  height: 100%;
  position: relative;
  .time_box {
    .architecture {
      margin-right: 10px;
      .architecturelabel {
        font: 400 14px "Microsoft YaHei";
        color: #666;
      }
    }
    .radio {
      margin-left: 10px;
    }
  }
  .SankeyBox {
    position: absolute;
    top: 80px;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    #Sankey {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
<style lang="scss">
.nlt {
  .el-radio {
    margin-right: 10px;
  }
}
</style>